import { useState, useEffect, useRef } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import imgLogo from './UPPL_FinishedPartsForm_Logo.png';
import rightLogo from './right_bar.jpg';
import SectionC from './Section3Images/SectionC.png';
import SectionD1 from './Section3Images/SectionD1.png';
import SectionE2 from './Section3Images/SectionE2.png';
import SectionE3 from './Section3Images/SectionE3.png';
import SectionE4 from './Section3Images/SectionE4.png';
import SectionF1 from './Section3Images/SectionF1.png';
import Pic1Img from './Section3Images/LabeledBaggedPartSectG.jpg';
import Pic2Img from './Section3Images/LabelSectG.jpg';
import Pic3Img from './Section3Images/CushioningMaterialSectG.png';
import Pic4Img from './Section3Images/OpenBoxWithPartInsideSectG.jpg';
import Pic5Img from './Section3Images/InsertsPadsStrapsOtherSectG.jpg';
import Pic6Img from './Section3Images/ClosedBoxWithLabelSectG.jpg';
import { useAuth } from 'oidc-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import validator from "validator";
import ImageUploadSection from "./ImageUploadSection";

function NewFinishedPartRequstForm() {
  const auth = useAuth();
  const [configJsonFile, setConfigJsonFile] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.PUBLIC_URL}/Config.json`);
        const data = await response.json();
        setConfigJsonFile(data);
        console.log("Json file read from the Public folder completed:");
      } catch (error) {
        console.error('Error fetching Config JSON file data:', error);
      }
    }
    fetchData();
  }, []);

  const [selectedSectionA_RowID, setSectionA_RowID] = useState("");
  const [SectionA_Rows, setSectionA_Rows] = useState([
    { id: 1, selected: false, number: '10', method: 'Physical protection - closed plastic bag, taped or sealed' },
    { id: 2, selected: false, number: '31', method: 'Waterproof bag - Closed plastic bag heat sealed' },
    { id: 3, selected: false, number: '33', method: 'Greaseproof - Waterproof - Closed plastic bag heat sealed' },
    { id: 4, selected: false, number: '41', method: 'Water Vaporproof bag or Anti-static - Bag sealed' },
    { id: 5, selected: false, number: 'AMS2817', method: 'Performad Packing - Opaque bag sealed' },
  ]);


  const handleSectionA_CheckboxChange = (id) => {
    setSectionA_Rows(SectionA_Rows.map(row => ({
      ...row,
      selected: row.id === id // Only the clicked checkbox is selected
    })));

    // if (id != "") {
    //   setSectionB_1_Rows(SectionB_1_Rows.map(row => ({
    //     ...row,
    //     selected: row.id === 1
    //   })));
    //   setSectionB_2_Rows(SectionB_2_Rows.map(row => ({
    //     ...row,
    //     selected: row.id === 3
    //   })));
    //   setSectionB_3_Rows(SectionB_3_Rows.map(row => ({
    //     ...row,
    //     selected: row.id === 3
    //   })));
    //   setSectionB1_RowID(1);
    //   setSectionB2_RowID(3);
    //   setSectionB3_RowID(3);
    // }
    setSectionA_RowID(id);
  };

  const [SectionB1_RowID, setSectionB1_RowID] = useState("");
  const [SectionB_1_Rows, setSectionB_1_Rows] = useState([
    { id: 1, selected: false, number: 'Non / Applicable', material: '' },
    { id: 2, selected: false, number: 'PK520', material: 'VCI MPI40 - Or equivalent PWC Lab. Approved' },
    { id: 3, selected: false, number: 'PK4856', material: 'VCI Alumitex AT35 - Or equivalent PWC Lab. Approved' },
    { id: 4, selected: false, number: 'PK5215', material: 'VCI Silver Saver - Or equivalent PWC Lab. Approved' },
    { id: 5, selected: false, number: 'PK5270', material: 'VCI Coppertex - Or equivalent PWC Lab. Approved' },
    { id: 6, selected: false, number: 'Blue Bag’s', material: 'VCI Poly Film - Daubert Cromwell. Min thickness .004”. Can be used as PK520 (VCI MPI40)' },
  ]);

  const handleSectionB_1_CheckboxChange = (id) => {
    setSectionB_1_Rows(SectionB_1_Rows.map(row => ({
      ...row,
      selected: row.id === id
    })));
    setSectionB1_RowID(id);
  };

  const [SectionB2_RowID, setSectionB2_RowID] = useState("");
  const [SectionB_2_Rows, setSectionB_2_Rows] = useState([
    { id: 1, selected: false, material: 'Lab. Approved sources, MIL-PRF-8188 - Preservative oil engine compatible PK2802' },
    { id: 2, selected: false, material: 'Lab. Approved sources, MIL-PRF-6085 - Ball and Roller Bearings only' },
    { id: 3, selected: false, material: 'Non / Applicable' },
  ]);

  const handleSectionB_2_CheckboxChange = (id) => {
    setSectionB_2_Rows(SectionB_2_Rows.map(row => ({
      ...row,
      selected: row.id === id
    })));
    setSectionB2_RowID(id);
  };


  const [SectionB3_RowID, setSectionB3_RowID] = useState("");
  const [SectionB_3_Rows, setSectionB_3_Rows] = useState([
    { id: 1, selected: false, material: 'MIL-PRF-6081 (grade 1010)' },
    { id: 2, selected: false, material: 'MIL-PRF-6083' },
    { id: 3, selected: false, material: 'Non / Applicable' },
  ]);

  const handleSectionB_3_CheckboxChange = (id) => {
    setSectionB_3_Rows(SectionB_3_Rows.map(row => ({
      ...row,
      selected: row.id === id
    })));
    setSectionB3_RowID(id);
  };


  const getEnabledRows = () => {
    switch (selectedSectionA_RowID) {
      case 1:
        return [1, 2, 5];
      case 2:
      case 3:
        return [1, 2];
      case 4:
        return [3, 6];
      case 5:
        return [4];
      default:
        return [];
    }
  };

  const enabledRows = getEnabledRows();
  const [SectionC2_RowID, setSectionC2_RowID] = useState("");
  const [SectionC_2_Rows, setSectionC_2_Rows] = useState([
    { id: 1, selected: false, description: 'Polyethylene Envelope - Clear Plastic bag, min 0.004 /0.101mm thickness. Preservation method 10, 31 or 33' },
    { id: 2, selected: false, description: 'Polyethylene Tube - Clear Plastic sleeve tubing min 0.004 / 0.1010mm thickness. Preservation method 10, 31 or 33' },
    { id: 3, selected: false, description: 'Envelope MVI - Water vaporproof bag, MIL-PRF-131 Class 1 (MVI Aluminum bag) or MIL-PRF-22191 Type I, Class I (Transparent bag). Preservation method 41' },
    { id: 4, selected: false, description: 'Envelope Opaque - Kraft or plastic: black or white frosted MIL-DTL-117, Type II, Class C, Style I Preservation Method AMS2817 O\'ring' },
    { id: 5, selected: false, description: 'Envelope Padded - Kraft Air Cellular Cushioning. Envelope paper / Interior bubble air liner Preservation Method 10 only' },
    { id: 6, selected: false, description: 'Envelope Anti-Static - ESD (Electrostatic Discharge Protection) MIL-PRF-81705D, Type 1, Class 1. Barrier Materaials, Flexible, Electrostatic Discharge Protective, Heat sealable. Aluminum bag. Preservation method 41' },
  ]);

  const handleSectionC_2_CheckboxChange = (id) => {
    setSectionC_2_Rows(SectionC_2_Rows.map(row => ({
      ...row,
      selected: row.id === id
    })));
    setSectionC2_RowID(id);
  };



  const [SectionC_3_Rows, setSectionC_3_Rows] = useState([
    { id: 1, label: 'PK', text: '', type: 'Number' },
    { id: 2, label: 'Length:', text: '', type: 'Inches' },
    { id: 3, label: 'Width:', text: '', type: 'Inches' },
    { id: 4, label: 'Thickness:', text: '', type: 'Inches' },
    { id: 5, label: 'Quantity per bag:', text: '', type: 'Pcs' },
  ]);

  const handleSectionC_3_TextChange = (id, value) => {
    setSectionC_3_Rows(SectionC_3_Rows.map(row =>
      row.id === id ? { ...row, text: value } : row
    ));
  };

  const [selectedSectionD_Rows_Ids, setSelectedSectionD_Rows_Ids] = useState({});

  const [SectionD_Rows, setSectionD_Rows] = useState([
    { id: 1, selected: false, description: 'Bubble wrap (small air cap)', text: 'PK260' },
    { id: 2, selected: false, description: 'Paper crimped multi-ply', text: 'PK2612' },
    { id: 3, selected: false, description: 'Cardboard Pads', text: '' },
    { id: 4, selected: false, description: 'Cardboard Pilot Support Pads:', text: '' },
    { id: 5, selected: false, description: 'Korrvu CF Insert Air Suspension', text: 'N/A' },
    { id: 6, selected: false, description: 'Polyethylene Foam Insert Only critical parts (Approval requi)', text: 'N/A' },
  ]);

  const handleSectionD_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionD_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };
  const handleSectionD_PKTextChange = (event, id) => {
    
    const pxTextValue  = event.target.value;
    setSectionD_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, text: pxTextValue } : row
      )
    );
  }  

  const [SectionE_2_Rows, setSectionE_2_Rows] = useState([
    { id: 1, description: 'PK', text: '', type: 'Number' },
    { id: 2, description: 'Length', text: '', type: 'Inches' },
    { id: 3, description: 'Width', text: '', type: 'Inches' },
    { id: 4, description: 'Depth', text: '', type: 'Inches' },
    { id: 5, description: 'Quantity', text: '', type: 'Pcs per box' },
  ]);

  const handleSectionE_2_TextChange = (id, value) => {
    setSectionE_2_Rows(SectionE_2_Rows.map(row =>
      row.id === id ? { ...row, text: value } : row
    ));
  };

  const [SectionE3_RowID, setSectionE3_RowID] = useState("");
  const [SectionE_3_Rows, setSectionE_3_Rows] = useState([
    { id: 1, selected: false, container: 'Consolidation required' },
    { id: 2, selected: false, container: 'Non / Applicable' },
  ]);

  const handleSectionE_3_CheckboxChange = (id) => {
    setSectionE_3_Rows(SectionE_3_Rows.map(row => ({
      ...row,
      selected: row.id === id
    })));
    setSectionE3_RowID(id);
  };


  const [SectionE4_RowID, setSectionE4_RowID] = useState("");
  const [SectionE_4_Rows, setSectionE_4_Rows] = useState([
    { id: 1, selected: false, label: 'External Shipping Label per APPENDIX F Apply' },
    { id: 2, selected: false, label: 'ASN Bar Code Label - Authorized Suppliers' },
    { id: 3, selected: false, label: 'Document Enclosed - Packing slips shall be placed inside a plastic bag. taped or heat sealed and attached to the outside of the shipping container.' },
  ]);

const handleSectionE_4_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionE_4_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  // const handleSectionE_4_CheckboxChange = (id) => {
  //   setSectionE_4_Rows(SectionE_4_Rows.map(row => ({
  //     ...row,
  //     selected: row.id === id
  //   })));
  //   setSectionE4_RowID(id);
  // };


  const [selectedSectionF_Rows_Ids, setSelectedSectionF_Rows_Ids] = useState([]);

  const [SectionF_Rows, setSectionF_Rows] = useState([
    { id: 1, selected: false, type: 'LOT', label: 'In process Traceability Number - No bar code required' },
    { id: 2, selected: false, type: 'SER NO.', label: 'Serialization Number - Bar code required' },
    { id: 3, selected: false, type: 'UI NO.', label: 'Unique Identifier Number - Bar code required' },
    { id: 4, selected: false, type: 'USN NO.', label: 'Universal Serial Number - Bar code required' },
    { id: 5, selected: false, type: 'DETAIL', label: 'Details Label - Printable by supplier only - Bar code required' },
    { id: 6, selected: false, type: 'KIT', label: 'Kit Label - Bar code required' },
    { id: 7, selected: false, type: 'SHELF LIFE', label: 'Age Control Part Label - Bar code required' },
    { id: 8, selected: false, type: 'Pre-print Envelop Packing', label: 'Automated bar code printed directly on plastic bag' }
  ]);

  const handleSectionF_CheckboxChange = (event, id) => {
    const { checked } = event.target;
    setSectionF_Rows(prevRows =>
      prevRows.map(row =>
        row.id === id ? { ...row, selected: checked } : row
      )
    );
  };

  const [picture1, setPicture1] = useState(null);
  const [picture2, setPicture2] = useState(null);
  const [picture3, setPicture3] = useState(null);
  const [picture4, setPicture4] = useState(null);
  const [picture5, setPicture5] = useState(null);
  const [picture6, setPicture6] = useState(null);

  const handlePictureUpdate_1 = (newPic) => {
    setPicture1(newPic);
  };
  const handlePictureUpdate_2 = (newPic) => {
    setPicture2(newPic);
  };
  const handlePictureUpdate_3 = (newPic) => {
    setPicture3(newPic);
  };
  const handlePictureUpdate_4 = (newPic) => {
    setPicture4(newPic);
  };
  const handlePictureUpdate_5 = (newPic) => {
    setPicture5(newPic);
  };
  const handlePictureUpdate_6 = (newPic) => {
    setPicture6(newPic);
  };


  const navigate = useNavigate();
  const [apimessage, setAPIMessage] = useState('');
  const [modelPopupshow, setmodelPopupshow] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);

  // Vendor Information section fields

  const [VendorCode, setVendorCode] = useState("");
  const [VendorName, setVendorName] = useState("");
  const [VendorEmail, setVendorEmail] = useState("");
  const [PartNumber, setPartNumber] = useState("");
  const [OptionNumber, setOptionNumber] = useState("");
  const [VendorEmailCc, setVendorEmailCc] = useState("");
  const [SupplierComments1, setSupplierComments1] = useState("");
  const [SectionB_2_Comments, setSectionB_2_Comments] = useState("");
  const [SectionB_3_Comments, setSectionB_3_Comments] = useState("");
  const [SectionC_3_Comments, setSectionC_3_Comments] = useState("");
  const [SectionE_2_Comments, setSectionE_2_Comments] = useState("");
  const [InitiatorEmailAddress, setInitiatorEmailAddress] = useState("");
  const [initiatorEmailError, setInitiatorEmailError] = useState("");
  const [vendorEmailError, setVendorEmailError] = useState("");
  const [vendorEmailErrorcc, setVendorEmailErrorcc] = useState("");
  const [sipiComplianceSectionC, setSipiComplianceSectionC] = useState('');
  const [sipiComplianceSectionE, setSipiComplianceSectionE] = useState('');






  const [apiErrormessage, setApiErrormessage] = useState("");
  const [invalidVendorCode, setInvalidVendorCode] = useState("");

  const [isConfirmChecked, setIsConfirmChecked] = useState(false);
  const csrfToken = useRef(null);
  const cookieToken = useRef(null);
  const [loading, setLoading] = useState(false);



  let storedValue = localStorage.getItem("UPPAPFinishedPartsProcessID");
  let autoIncrementVal = "";
  let newProcessIDNum = "";

  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
  }

  // Form submit 
  const handleSubmit = async (event) => {

    //Form Validation all required dropdown values selected   
    const isEmailValid = formEmailValidation();
    const sectionA_isSelected = SectionA_Rows.some(row => row.selected);
    const sectionB1_isSelected = SectionB_1_Rows.some(row => row.selected);
    const sectionB2_isSelected = SectionB_2_Rows.some(row => row.selected);
    const sectionB3_isSelected = SectionB_3_Rows.some(row => row.selected);
    const sectionC2_isSelected = SectionC_2_Rows.some(row => row.selected);
    const sectionD_isSelected = SectionD_Rows.some(row => row.selected);
    const sectionE3_isSelected = SectionE_3_Rows.some(row => row.selected);
    const sectionE4_isSelected = SectionE_4_Rows.some(row => row.selected);
    const sectionF_isSelected = SectionF_Rows.some(row => row.selected);

    if (isEmailValid) {
      if (sectionA_isSelected && sectionB1_isSelected && sectionB2_isSelected && sectionB3_isSelected && sectionC2_isSelected && sectionD_isSelected && sectionE3_isSelected && sectionE4_isSelected && sectionF_isSelected) {
        if (picture1 != null && picture2 != null && picture3 != null && picture4 != null && picture6 != null) {
          if (sipiComplianceSectionC !== "" && sipiComplianceSectionE !== "") {
            const isSubmitConfirm = window.confirm('Are you sure you want to submit this request?');
            if (isSubmitConfirm) {
              event.preventDefault();
              setLoading(true);
              var CurrentYear = getCurrentDateTime();
              if (storedValue == null) {
                storedValue = 1;
              }

              // console.log("Auth User data Token: "+auth.userData.access_token);      
              var resTokenApiVal = auth.userData.access_token;
              // var resTokenApiVal = "";
              // Call API Start
              newProcessIDNum = Number(storedValue) + 1;
              if (storedValue === 1) {
                autoIncrementVal = String(storedValue).padStart(3, 0);
              }
              else {
                autoIncrementVal = String(newProcessIDNum).padStart(3, 0);
              }
              const requestId = selectedFile.length;
              // Create JSON File
              //{ GUID: configJsonFile.UPPAPFinishedPartsGuids.VendorName, sValue: VendorName, name: "Vendor Name" },{ GUID: configJsonFile.UPPAPFinishedPartsGuids.Marking_Method, sValue: MarkingMethod, name: "MarkingMethod" },

              var dictstring = {
                ProcessInfo: {
                  domainId: "UPPAPFinishedParts",
                  ProcessId: configJsonFile.UPPAPFinishedPartsGuids.NewUPPAPFinishedPartProcessID,
                  NewRequest: true,
                  InstanceNumber: "",
                  AttachmentID: "Att_" + configJsonFile.NewDPMSProcessId + "_" + CurrentYear + "_" + autoIncrementVal + "_" + requestId,
                  PathID: configJsonFile.UPPAPFinishedPartsGuids.PathID,
                  workflowID: configJsonFile.UPPAPFinishedPartsGuids.WorkflowGuid,
                  businessEntity: configJsonFile.UPPAPFinishedPartsGuids.BusinessEntityGuid,
                  dbId: configJsonFile.UPPAPFinishedPartsGuids.dbId,
                  formTypeId: configJsonFile.UPPAPFinishedPartsGuids.formTypeId,
                  BaseBPSPortalAddress: configJsonFile.BaseBPSPortalAddress,
                  WebconClientId: configJsonFile.WebconClientId,
                  WebconclientSecret: configJsonFile.WebconclientSecret,
                  WebconTokenURL: configJsonFile.WebconTokenURL
                },
                Form: [
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.InitiateUserID, sValue: InitiatorEmailAddress, name: "Initiator Email" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.PartNumber, sValue: PartNumber, name: "Part Number" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.VendorEmail, sValue: VendorEmail, name: "Vendor Email" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.VendorCode, sValue: VendorCode, name: "Vendor Code" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.VendorName, sValue: VendorName, name: "Vendor Name" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.VendorEmail_Cc, sValue: VendorEmailCc, name: "Vendor emailcc" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.OptionNumber, sValue: OptionNumber, name: "Option Number" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.Description, sValue: SupplierComments1, name: "Supplier Comments" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.B_2_Comments, sValue: SectionB_2_Comments, name: "Section B2 Comments" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.B_3_Comments, sValue: SectionB_3_Comments, name: "Section B3 Comments" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.B_3_Comments, sValue: SectionB_3_Comments, name: "Section B3 Comments" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SECTION_C_Yes_No, sValue: sipiComplianceSectionC, name: "Section C3 Yes/No" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.C_3_Comments, sValue: SectionC_3_Comments, name: "Section C3 Comments" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SECTION_E_Yes_No, sValue: sipiComplianceSectionE, name: "Section E Yes/No" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.E_2_Comments, sValue: SectionE_2_Comments, name: "Section E2 Comments" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionA_RowNum_Select, sValue: selectedSectionA_RowID.toString(), name: "Section A RowID" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionB1_RowNum_Select, sValue: SectionB1_RowID.toString(), name: "Section B1 RowID" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionB2_RowNum_Select, sValue: SectionB2_RowID.toString(), name: "Section B2 RowID" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionB3_RowNum_Select, sValue: SectionB3_RowID.toString(), name: "Section B3 RowID" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionC2_RowNum_Select, sValue: SectionC2_RowID.toString(), name: "Section C2 RowID" },
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionE3_RowNum_Select, sValue: SectionE3_RowID.toString(), name: "Section E3 RowID" },                  
                  { GUID: configJsonFile.UPPAPFinishedPartsGuids.IsDataFromReact, sValue: "true", name: "IsDataFromReact" }
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.SectionE4_RowNum_Select, sValue: SectionE4_RowID.toString(), name: "Section E4 RowID" }
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.Labeled_bagged_part_Img_Guid, sValue: picture1, name: "Picture" },
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.Label_Img_Guid, sValue: picture2, name: "Picture" },
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.Cushioning_material_Img_Guid, sValue: picture3, name: "Picture" },
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.OpenBoxWithPartInside_Img_Guid, sValue: picture4, name: "Picture" },
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.Inserts_pads_straps_Img_Guid, sValue: picture5, name: "Picture" },
                  // { GUID: configJsonFile.UPPAPFinishedPartsGuids.ClosedBoxWithLabel_Img_Guid, sValue: picture6, name: "Picture" },
                ],
                Section_C_3_RowData: SectionC_3_Rows,
                Section_C_3_RowDataListGuids: {
                  SelectGuid: configJsonFile.UPPAPFinishedPartsGuids.C_3_TextGuid,
                  SectionsItemListGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_C_3_ItemListGuid
                },
                Section_D_RowData: SectionD_Rows,
                Section_D_RowDataListGuids: {
                  SelectGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_D_Select_Guid,
                  SectionsItemListGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_D_ItemListGuid
                },
                Section_E_2_RowData: SectionE_2_Rows,
                Section_E_2_RowDataListGuids: {
                  SelectGuid: configJsonFile.UPPAPFinishedPartsGuids.E_2_TextGuid,
                  SectionsItemListGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_E_2_ItemListGuid
                },
                Section_F_RowData: SectionF_Rows,
                Section_F_RowDataListGuids: {
                  SelectGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_F_Select_Guid,
                  SectionsItemListGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_F_ItemListGuid
                },
                Section_D_RowTextData: SectionD_Rows,
                Section_D_RowTextDataListGuids: {
                  SelectGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_D_Pk_Guid,
                  SectionsItemListGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_D_PK_ItemListGuid
                },
                Section_E_4_RowData: SectionE_4_Rows,
                Section_E_4_RowDataListGuids: {
                  SelectGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_E_4_Select_Guid,
                  SectionsItemListGuid: configJsonFile.UPPAPFinishedPartsGuids.Section_E_4_ItemListGuid
                },
                Section_B_1_RowData: [],
                Section_B_1_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                 Section_C_RowData: [],
                Section_C_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                 Section_D_RM_RowData: [],
                Section_D_RM_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                 Section_E_1_RowData: [],
                Section_E_1_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                 Section_E_2_RM_RowData: [],
                Section_E_2_RM_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                 Section_E_3_RowData: [],
                Section_E_3_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                  Section_E_3b_RowData: [],
                Section_E_3b_RowDataListGuids: {
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                  Section_E_4_RM_RowData: [],
                Section_E_4_RM_RowDataListGuids: { 
                  SelectGuid: "",  
                  SectionsItemListGuid: ""  
                },
                  Section_E_5_RowData: [],
                Section_E_5_RowDataListGuids: { 
                  SelectGuid: "",  
                  SectionsItemListGuid: ""  
                },
                  Section_E_5b_RowData: [],
                Section_E_5b_RowDataListGuids: {  
                  SelectGuid: "", 
                  SectionsItemListGuid: "" 
                },
                    Section_E_6_RowData: [],
                Section_E_6_RowDataListGuids: { 
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },  
                  Section_E_7_RowData: [],
                Section_E_7_RowDataListGuids: { 
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                    Section_F_RM_RowData: [],
                Section_F_RM_RowDataListGuids: { 
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                },
                 Section_G_RowData: [],
                Section_G_RowDataListGuids: { 
                  SelectGuid: "",
                  SectionsItemListGuid: ""
                } 
              };
              //alert(dictstring);
              var stringifyObj = JSON.stringify(dictstring);
              console.log(dictstring);
              CallWebAPI(stringifyObj, resTokenApiVal);

              // Update Session variable to get increment num
              localStorage.setItem("UPPAPFinishedPartsProcessID", newProcessIDNum);
              // Call API End 
            }
          } else {
            alert("Please make sure Section C.1 or Section E.1 should be required (Yes/No)...!");
            event.preventDefault();
          }
        } else {
          alert("Please make sure in Section G all photos are required except 'Inserts, pads, straps, others'...!");
          event.preventDefault();
        }
      }
      else {
        alert("Please make sure at least one checkbox should be selected on each section...!");
        event.preventDefault();
      }
    } else {
      alert("Please fill the all required fields (or) Enter valid email address..!");
      event.preventDefault();
    }

  }

  // const formValidation = () => {
  //     var isFormValid = true;
  //     if (RequestType === "0#-- Select --" || Request_requiring_special_approval === "0#-- Select --" || ApplicableMarkingSpec === "0#-- Select --" || MarkingMethod === "0#-- Select --" || DrawingType === "0#-- Select --" || RegulatoryInspection === "0#-- Select --" || TracebilityRequirement === "0#-- Select --" || AdditionalTracebility === "0#-- Select --" || TwoDDataMatrixRequirment === "0#-- Select --" || SelectLablePartTraceability === "0#-- Select --") {
  //         isFormValid = false;
  //     }
  //     if (RequestType === "" || Request_requiring_special_approval === "" || ApplicableMarkingSpec === "" || MarkingMethod === "" || DrawingType === "" || RegulatoryInspection === "" || TracebilityRequirement === "" || AdditionalTracebility === "" || TwoDDataMatrixRequirment === "" || SelectLablePartTraceability === "") {
  //         isFormValid = false;
  //     }
  //     return isFormValid;
  // }
  const formEmailValidation = () => {
    var isFormEmailsValid = false;
    if (validator.isEmail(VendorEmail)) {
      isFormEmailsValid = true;
    }
    return isFormEmailsValid;
  }

//   const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
//   Call API to upload files to S3
//   const CallWebAPI = async (requestBody, getTokeVal) => {
//   try {
//     console.log("Attempting to API call to create/update instance..!");

//     const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_UPPAP_Url);
//     if (!isValidDomain(parsedUrl.hostname)) throw new Error("Invalid domain");

//     Use await instead of .then
//     const res = await axios.post(parsedUrl.href, requestBody, {
//       headers: {
//         "Content-Type": "application/json",
//         "x-api-id": configJsonFile.ClientId,
//         "Authorization": "Bearer " + getTokeVal,
//         "RequestVerificationToken": csrfToken.current
//       }
//     });

//     if (res.status === 201 || res.status === 200 || res.status === 202) {
//       const elementID = res.data;

//       base64ToBlob is async -> must await
//       const Pic1bolb = await base64ToBlob(picture1, "image/png");
//       const Pic2bolb = await base64ToBlob(picture2, "image/png");
//       const Pic3bolb = await base64ToBlob(picture3, "image/png");
//       const Pic4bolb = await base64ToBlob(picture4, "image/png");
//       const Pic6bolb = await base64ToBlob(picture6, "image/png");

//       Upload picture fields one-by-one with 40s delay between calls
//       await CallWebAPIUploadSectionGFileToS3(Pic1bolb, 1, getTokeVal, elementID, "Labeledbaggedpart.png");
//       await sleep(40000);

//       await CallWebAPIUploadSectionGFileToS3(Pic2bolb, 2, getTokeVal, elementID, "Label.png");
//       await sleep(40000);

//       await CallWebAPIUploadSectionGFileToS3(Pic3bolb, 3, getTokeVal, elementID, "Cushioningmaterial.png");
//       await sleep(40000);

//       await CallWebAPIUploadSectionGFileToS3(Pic4bolb, 4, getTokeVal, elementID, "Openboxwithpartinside.png");
//       await sleep(40000);

//       if (picture5 !== null) {
//         const Pic5bolb = await base64ToBlob(picture5, "image/png");
//         await CallWebAPIUploadSectionGFileToS3(Pic5bolb, 5, getTokeVal, elementID, "Insertspadsstrapsothers.png");
//         await sleep(40000);
//       }

//       await CallWebAPIUploadSectionGFileToS3(Pic6bolb, 6, getTokeVal, elementID, "Closedboxwithlabel.png");
//       await sleep(40000);
//       Then upload selected files one-by-one with 40s delay
//       if (selectedFile.length > 0) {
//         for (let i = 0; i < selectedFile.length; i++) {
//           const Num = i + 1;
//           await CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
//           if (i < selectedFile.length - 1) {
//             await sleep(40000);
//           }
//         }
//       }

//       setLoading(false);
//       setmodelPopupshow(true);
//       setApiErrormessage("");
//     } else {
//       console.log("Status Code:", res.status);
//       console.log("Status Data:", res.data);
//       setLoading(false);
//     }

//     console.log("... Attempt completed!");
//   } catch (error) {
//     console.log(error);
//     setLoading(false);

//     if (error?.response) {
//       console.log("Error response:", error.response.data);
//       setApiErrormessage(error.response.data || "An error occurred");
//     } else {
//       setApiErrormessage(String(error));
//     }

//     window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
//   }
// };

const CallWebAPI = async (requestBody, getTokeVal) => {
    try {
      console.log("Attempting to API call to create/update instance..!");
      const parsedUrl = new URL(configJsonFile.Server_Webcon_Creation_UPPAP_Url);
      if (!isValidDomain(parsedUrl.hostname)) {
        throw new Error('Invalid domain');
      }
      const axiosInstance = axios.create({
        baseURL: configJsonFile.Server_Webcon_Creation_UPPAP_Url,
        allowAbsoluteUrls: false
      });
      // "https://localhost:7216/WebconCreationUPPAP"
      axios.post(parsedUrl, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal,
          'RequestVerificationToken': csrfToken.current
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          var elementID = res.data;
          var Pic1bolb = base64ToBlob(picture1);
          var Pic2bolb = base64ToBlob(picture2);
          var Pic3bolb = base64ToBlob(picture3);
          var Pic4bolb = base64ToBlob(picture4);        
          var Pic6bolb = base64ToBlob(picture6);
          CallWebAPIUploadSectionGFileToS3(Pic1bolb, 1, getTokeVal, elementID,"Labeledbaggedpart.png");
          console.log("After Pic1 upload");
          CallWebAPIUploadSectionGFileToS3(Pic2bolb, 2, getTokeVal, elementID,"Label.png");
          console.log("After Pic2 upload");
          CallWebAPIUploadSectionGFileToS3(Pic3bolb, 3, getTokeVal, elementID,"Cushioningmaterial.png");
          console.log("After Pic3 upload");
          CallWebAPIUploadSectionGFileToS3(Pic4bolb, 4, getTokeVal, elementID,"Openboxwithpartinside.png");
          console.log("After Pic4 upload");
          if(picture5 !== null){
            var Pic5bolb = base64ToBlob(picture5);
            CallWebAPIUploadSectionGFileToS3(Pic5bolb, 5, getTokeVal, elementID,"Insertspadsstrapsothers.png");
            console.log("After Pic5 upload");
          }          
          CallWebAPIUploadSectionGFileToS3(Pic6bolb, 6, getTokeVal, elementID,"Closedboxwithlabel.png");
          console.log("After Pic6 upload");
          if (selectedFile.length > 0) {
            for (let i = 0; i < selectedFile.length; i++) {
              // upload each file to S3 calling API here
              let Num = i + 1;
              CallWebAPIUploadFileToS3(selectedFile[i], Num, getTokeVal, elementID);
              console.log("After Attachments " + Num + " upload");
            }
          }
          else {
            setLoading(false);
            setmodelPopupshow(true);
            setApiErrormessage("");
          }
          //setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
          console.log("Status Data:" + res.data);
        }
            setLoading(false);
            setmodelPopupshow(true);
            setApiErrormessage("");
      }).catch(error => {
        if (error.response) {
          console.log('Error response:', error.response.data);
          setLoading(false);
          setApiErrormessage(error.response.data || 'An error occurred');
          if (error.response.data.includes('Vendor Code')) {
            setInvalidVendorCode("Invalid");
            setApiErrormessage("Vendor Code '" + VendorCode + "' does not exist, Please enter correct value and submit again.")
          } else {
            setInvalidVendorCode("");
          };
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
      });
      console.log("... Attempt completed!");
    } catch (err) {
      console.log(err);
      console.log("Error Json:" + err.toJSON());
      setAPIMessage("Failed Due to:" + err);
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  function base64ToBlob(base64, contentType = 'application/octet-stream'){
  // base64 may come as "data:<mime>;base64,...." — strip the prefix if present
  const parts = base64.split(',');
  const b64 = parts.length > 1 ? parts[1] : parts[0];

  const byteChars = atob(b64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: contentType });
}

const CallWebAPIUploadSectionGFileToS3 = async (requestBody, num, getTokeVal, elementID,fileSectionGName) => {
    try {
      let FileNameWithoutSpace = fileSectionGName.replaceAll(" ","");
      let fileNameVal = elementID + "_" + num + "-" + FileNameWithoutSpace;
      //let fileNameVal = elementID + "_" + num + "-" + requestBody.name;
      console.log("FileName: " + fileNameVal);
      const formData = new FormData();
      formData.append('file', requestBody);
      formData.append('fileName', fileNameVal);
      formData.append('processID', "");
      formData.append('cookie', cookieToken.current);
      // https://localhost:5001/documents
      // configJsonFile.Server_Upload_FilesToS3_APIUrl
      axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          //setLoading(false);
          //setmodelPopupshow(true);
          setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
        }
      });

    } catch (err) {
      setLoading(false);
      setApiErrormessage(err.response.data || 'An error occurred');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const CallWebAPIUploadFileToS3 = async (requestBody, num, getTokeVal, elementID) => {
    try {
      let FileNameWithoutSpace = requestBody.name.replaceAll(" ", "");
      let fileNameVal = elementID + "_" + num + "-" + FileNameWithoutSpace;
      console.log("FileName: " + fileNameVal);
      const formData = new FormData();
      formData.append('file', requestBody);
      formData.append('fileName', fileNameVal);
      formData.append('processID', "");
      formData.append('cookie', cookieToken.current);

      axios.post(configJsonFile.Server_Upload_FilesToS3_APIUrl, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-api-id': configJsonFile.ClientId,
          'Authorization': "Bearer " + getTokeVal
        }
      }).then(res => {
        if (res.status === 201 || res.status === 200 || res.status === 202) {
          //setLoading(false);
          //setmodelPopupshow(true);
          setAPIMessage("Files are uploaded successfully to AWS S3");
        } else {
          console.log("Status Code:" + res.status);
        }
      });

    } catch (err) {
      setLoading(false);
      setApiErrormessage(err.response.data || 'An error occurred');
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

  }

  const isValidDomain = (domain) => {
    const allowedDomains = ['apid.pwc.ca', 'apiq-ext.pwc.ca', 'api-ext.pwc.ca'];
    return allowedDomains.includes(domain);
  };

  const onClickHomeHandler = async (event) => {
    const isConfirmedHome = window.confirm('You might loose the data, Are you sure you want to go to home page?');
    if (isConfirmedHome) {
      navigate('/');
    }
  }
  const onClickCancelHandler = async (event) => {
    const isConfirmedCancel = window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if (isConfirmedCancel) {
      navigate('/');
    }

  }

  const handleOkButtonModelPopup = () => {
    navigate('/');
    setmodelPopupshow(false);
  }

  const handleChangeConfirmCheckbox = () => {
    setIsConfirmChecked(!isConfirmChecked);
  }







  const validateInitiatorEmail = (e) => {
    const email = e.target.value;
    if (validator.isEmail(email)) {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("");
    } else {
      setInitiatorEmailAddress(e.target.value);
      setInitiatorEmailError("Please Enter valid Email");
    }
  }
  const validateVendorEmail = (e) => {
    const vEmail = e.target.value;
    if (validator.isEmail(vEmail)) {
      setVendorEmail(e.target.value)
      setVendorEmailError("");
    } else {
      setVendorEmail(e.target.value)
      setVendorEmailError("Please Enter valid Email");
    }
  }
  const validateVendorEmailcc = (e) => {
    const vEmailcc = e.target.value;
    if (validator.isEmail(vEmailcc)) {
      setVendorEmailCc(e.target.value)
      setVendorEmailErrorcc("");
    } else {
      setVendorEmailCc(e.target.value)
      setVendorEmailErrorcc("Please Enter valid Email");
    }
  }


  //auth && auth.userData
  if (auth && auth.userData) {
    return (
      <form onSubmit={handleSubmit}>
        <style>{`
          /* Increase checkbox size for this form only */
          form input[type='checkbox'] {
            width: 22px;
            height: 22px;
            accent-color: #1f2a44;
            vertical-align: middle;
          }
        `}</style>
        <div class="container">
          <div class="row">
            <div class="col-8 p-0">
              <img src={imgLogo} alt="Logo" width="100%" height="80%" />
            </div>
            <div class="col-4 p-0">
              <img src={rightLogo} alt="Logo" width="100%" height="80%" />
            </div>
          </div>
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">VENDOR MANUFACTURING INFORMATION</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div class="row"><label style={{ color: 'red' }}>{apiErrormessage}</label> </div>
            <div class="row">
              <div class="col-2">
                <label for="InitiatorEmailAddress">Initiator User ID<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={InitiatorEmailAddress}
                  onChange={(e) => setInitiatorEmailAddress(e.target.value)}
                  placeholder="Enter Initiator User ID" required />
              </div>
            </div>
            <div class="row">
              <div class="col-2" style={{ width: '17%' }}>
                <label for="PartNumber">Part Number<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4" style={{ width: '33%', paddingLeft: '6px' }}>
                <input type="text"
                  value={PartNumber}
                  onChange={(e) => setPartNumber(e.target.value)}
                  placeholder="Enter Part Number" required />
              </div>
              <div class="col-2">
                <label for="vendorEmail">Vendor Email<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmail}
                  onChange={(e) => validateVendorEmail(e)}
                  placeholder="Enter Vendor email" required />
                <div style={{ color: 'red' }}>{vendorEmailError}</div>
              </div>

            </div>
            <div class="row">
              <div class="col-2">
                <label for="vendorCode">Vendor Code<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="number"
                  value={VendorCode}
                  onChange={(e) => setVendorCode(e.target.value)}
                  placeholder="Enter Vendor code" required style={{ borderColor: invalidVendorCode ? 'red' : '' }} />
              </div>
              <div class="col-2">
                <label for="vendorName">Vendor Name<label style={{ color: 'red' }}>*</label></label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorName}
                  onChange={(e) => setVendorName(e.target.value)}
                  placeholder="Enter Vendor Name" required />
              </div>
            </div>


            <div class="row">
              <div class="col-2">
                <label for="OptionNumber">Option Number</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={OptionNumber}
                  onChange={(e) => setOptionNumber(e.target.value)}
                  placeholder="Enter Option Number" />
              </div>
              <div class="col-2">
                <label for="VendorEmailCc">VendorEmail (Cc)</label>
              </div>
              <div class="col-4">
                <input type="text"
                  value={VendorEmailCc}
                  onChange={(e) => validateVendorEmailcc(e)}
                  placeholder="Enter Vendor Email Cc" />
                <div style={{ color: 'red' }}>{vendorEmailErrorcc}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="SupplierComments1">Description</label>
              </div>
              <div class="col-10">
                <textarea class="VendorComments" id="Comments" name="Comments" value={SupplierComments1} placeholder="Enter Supplier Comments" onChange={(e) => setSupplierComments1(e.target.value)} ></textarea>
              </div>
            </div>
          </div>



          {/*Section A  */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION A - PRESERVATION METHOD</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Select performed Preservation Method as per SIPI portal line</label>
            <div class="row">
              <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Select <label style={{ color: 'red' }}>*</label></th>
                    <th>Number</th>
                    <th>Method</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionA_Rows.map(row => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={() => handleSectionA_CheckboxChange(row.id)}
                        />
                      </td>
                      <td>{row.number}</td>
                      <td>{row.method}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>



          </div>

          {/* Section B*/}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION B - PRESERVATION MATERIAL</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <h5><b>B.1) Preservation Material</b></h5>
            <label>Select performed Preservation Method as per SIPI portal line</label>
            <div class="row">
              <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Select <label style={{ color: 'red' }}>*</label></th>
                    <th>Number</th>
                    <th>Preservation Material</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionB_1_Rows.map(row => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={() => handleSectionB_1_CheckboxChange(row.id)}                          
                        />
                      </td>
                      <td>{row.number}</td>
                      <td>{row.material}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <br />
            <h5><b>B.2) Preservative Oil applied MIL-PRF-8188</b></h5>
            <label>Select performed Preservation Method as per SIPI portal line, if applicable</label>
            <div class="row">
              <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Select <label style={{ color: 'red' }}>*</label></th>
                    <th>Preservation Material</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionB_2_Rows.map(row => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={() => handleSectionB_2_CheckboxChange(row.id)}                          
                        />
                      </td>
                      <td>{row.material}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="SupplierComments1">Comments</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea class="VendorComments" id="Comments" name="Comments" value={SectionB_2_Comments} placeholder="Enter Comments" onChange={(e) => setSectionB_2_Comments(e.target.value)} ></textarea>
              </div>
            </div>
            <h5><b>B.3) Part’s with Internal Preservative fluid Lab</b></h5>
            <label>Select performed Preservation Method as per SIPI portal line, if applicable</label>
            <div class="row">

              <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Select <label style={{ color: 'red' }}>*</label></th>
                    <th>Preservation Material</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionB_3_Rows.map(row => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={() => handleSectionB_3_CheckboxChange(row.id)}                          
                        />
                      </td>
                      <td>{row.material}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
            <div class="row">
              <div class="col-2">
                <label for="SupplierComments1">Comments</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea class="VendorComments" id="Comments" name="Comments" value={SectionB_3_Comments} placeholder="Enter Comments" onChange={(e) => setSectionB_3_Comments(e.target.value)} ></textarea>
              </div>
            </div>
          </div>


          {/* Section C */}

          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION C - ENVELOPE</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div style={{ fontFamily: 'Arial' }}>
              <div style={{ marginBottom: '15px' }}>
                <h5><b>C.1) SIPI Compliance</b></h5>
                <div class="row bordered-box">
                  <div class="col-6">
                    <label htmlFor="sipi-compliance">
                      Do the dimensions below comply with SIPI specifications? <label style={{ color: 'red' }}>*</label>
                    </label>
                  </div>
                  <div class="col-3">
                    <select
                      id="sipi-compliance"
                      value={sipiComplianceSectionC}
                      onChange={(e) => setSipiComplianceSectionC(e.target.value)}
                      style={{ padding: '5px', width: '200px', marginTop: '8px' }}
                      required >
                      <option value="">-- Select --</option>
                      <option value="1#Yes">Yes</option>
                      <option value="2#No">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <h5><b>C.2) Envelope Type</b></h5>
              </div>
            </div>

            <div class="row">

              <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th style={{ width: '102px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                    <th>Envelope Description</th>
                  </tr>
                </thead>
                <tbody>
                  {SectionC_2_Rows.map(row => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.selected}
                          onChange={() => handleSectionC_2_CheckboxChange(row.id)}                          
                        />
                      </td>
                      <td>{row.description}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
            <div>
              <h5><b>C.3) Envelop Dimensions & Quantity</b></h5>
            </div>
            <div class="row bordered-box">

              <div class="col-6" style={{ height: '360px' }}>
                <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Value <label style={{ color: 'red' }}>*</label></th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SectionC_3_Rows.map(row => (
                      <tr key={row.id}>
                        <td>{row.label}</td>
                        <td>
                          <input
                            type="text"
                            value={row.text}
                            onChange={(e) => handleSectionC_3_TextChange(row.id, e.target.value)}
                            required={row.label!="PK"} />
                        </td>
                        <td>{row.type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div class="col-5" style={{ height: '360px' }}>
                <img src={SectionC} alt="A-Logo" width="95%" height="95%" />
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="Section C.3 Comments">Comments {sipiComplianceSectionC=="2#No"? <label style={{ color: 'red' }}>*</label>:""}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea class="VendorComments" id="Comments" name="Comments" value={SectionC_3_Comments} placeholder="Enter Comments" onChange={(e) => setSectionC_3_Comments(e.target.value)} required={sipiComplianceSectionC=="2#No"}></textarea>
              </div>
            </div>
          </div>


          {/* Section D */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION D - CUSHIONING AND DUNNAGE MATERIAL:</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Check cushioning material used as per SIPI portal</label>
            <div class="row bordered-box">
              <div class="col-6" style={{ height: "320px" }}>
                <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th style={{ width: '102px' }}>Check <label style={{ color: 'red' }}>*</label></th>
                      <th>Description</th>
                      <th>PK</th>
                    </tr>
                  </thead>
                  <tbody>


                    {SectionD_Rows.map(row => (
                      <tr key={row.id}>
                        <td>
                          <input
                            type="checkbox"
                            checked={row.selected}
                            onChange={(e) => handleSectionD_CheckboxChange(e, row.id)}
                          />
                        </td>
                        <td>{row.description}</td>
                        <td><input
                          type="text"
                          value={row.text}
                          onChange={(e) => handleSectionD_PKTextChange(e, row.id)}
                          required={row.selected} /></td>
                        {/* <td>{row.pk}</td> */}
                      </tr>
                    ))}

                    {/*SectionD_Rows.map(item => (
                      <tr key={item.id}>
                        <td>
                          <input
                            type="checkbox"
                            name={item.id}
                            checked={selectedSectionD_Rows_Ids[item.id] || false}
                            onChange={handleSectionD_CheckboxChange}
                          />
                        </td>
                        <td>{item.description}</td>
                        <td>{item.pk}</td>
                      </tr>
                    ))*/}
                  </tbody>
                </table>
              </div>
              <div class="col-5" style={{ height: "380px" }}>
                <img src={SectionD1} alt="A-Logo" width="100%" height="97%" />
              </div>
            </div>
          </div>
          {/* Section E */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION E - UNIT - UNIT, INTERMEDIATE & SHIPPING CONTAINER LABEL</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <div style={{ fontFamily: 'Arial' }}>
              <div style={{ marginBottom: '15px' }}>
                <h5><b>E.1) SIPI Compliance</b></h5>
                <div class="row bordered-box">
                  <div class="col-6">
                    <label htmlFor="sipi-compliance">
                      Do the dimensions below comply with SIPI specifications? <label style={{ color: 'red' }}>*</label>
                    </label>
                  </div>
                  <div class="col-3">
                    <select
                      id="sipi-compliance"
                      value={sipiComplianceSectionE}
                      onChange={(e) => setSipiComplianceSectionE(e.target.value)}
                      style={{ padding: '5px', width: '200px', marginTop: '8px' }}
                      required >
                      <option value="">-- Select --</option>
                      <option value="1#Yes">Yes</option>
                      <option value="2#No">No</option>
                    </select>
                  </div>
                </div>
              </div>
              <div>
                <h5><b>E.2) Unit</b></h5>
              </div>
            </div>
            <div class="row bordered-box">
              <div class="col-6">
                <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>Description</th>
                      <th>Value <label style={{ color: 'red' }}>*</label></th>
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SectionE_2_Rows.map(row => (
                      <tr key={row.id}>
                        <td>{row.description}</td>
                        <td>
                          <input
                            type="text"
                            value={row.text}
                            onChange={(e) => handleSectionE_2_TextChange(row.id, e.target.value)}
                          required={row.description!="PK"}/>
                        </td>
                        <td>{row.type}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div class="col-5" style={{ height: "320px" }}>
                <img src={SectionE2} alt="A-Logo" width="100%" height="97%" />
              </div>
            </div>
            <div class="row">
              <div class="col-2">
                <label for="Section E.2 Comments">Comments {sipiComplianceSectionE=="2#No"? <label style={{ color: 'red' }}>*</label>:""}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <textarea class="VendorComments" id="Comments" name="Comments" value={SectionE_2_Comments} placeholder="Enter Comments" onChange={(e) => setSectionE_2_Comments(e.target.value)} required={sipiComplianceSectionE=="2#No"}></textarea>
              </div>
            </div>
            <div>
              <h5><b>E.3) Intermediate Container</b></h5>
            </div>
            <label>As per CPW40 Intermediate Container Description & SIPI portal Only when consolidation required (Multiple unit container of the same part number into Shipping Container). Select the option below.</label>
            <div class="row bordered-box">

              <div class="col-6">
                <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Select <label style={{ color: 'red' }}>*</label></th>
                      <th>Intermediate Container</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SectionE_3_Rows.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={row.selected}
                            onChange={() => handleSectionE_3_CheckboxChange(row.id)}
                          />
                        </td>
                        <td>{row.container}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div class="col-5" style={{ height: "360px" }}>
                <img src={SectionE3} alt="SectionE2-Logo" width="350px" height="360px" />
              </div>

            </div>
            <h5><b>E.4) Shipping Container Label</b></h5><br />
            <label>As per CPW40 Shipping Container description & SIPI portal, select the label</label>
            <div class="row bordered-box">
              <div class="col-6">
                <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th style={{ width: '102px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                      <th>Label</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SectionE_4_Rows.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={row.selected}
                            onChange={(e) => handleSectionE_4_CheckboxChange(e, row.id)}
                          />
                        </td>
                        <td>{row.label}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div class="col-5" style={{ height: "320px" }}>
                <img src={SectionE4} alt="SectionE3-Logo" width="100%" height="97%" />
              </div>
            </div>
          </div>

          {/* Section F */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION F - BARCODE LABEL & OTHERS</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Select a label used as per CPW40 Bar Code Labels.</label>
            <div class="row bordered-box">
              <div class="col-6">
                <table border="1" cellPadding="10" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th style={{ width: '100px' }}>Select <label style={{ color: 'red' }}>*</label></th>
                      <th>Type</th>
                      <th>CPW40 Bar Code Labels</th>
                    </tr>
                  </thead>
                  <tbody>
                    {SectionF_Rows.map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={row.selected}
                            onChange={(e) => handleSectionF_CheckboxChange(e, row.id)}
                          />
                        </td>
                        <td>{row.type}</td>
                        <td>{row.label}</td>
                      </tr>
                    ))
                    }
                  </tbody>
                </table>
              </div>
              <div class="col-5" style={{ height: "320px" }}>
                <img src={SectionF1} alt="SectionE3-Logo" width="100%" height="97%" />
              </div>
            </div>
          </div>

          {/* Section G */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">SECTION G - PHOTOS</h5></div></div>
          <div class="marginLeft" Id="InitialFields">
            <label>Please supply evidence of packaging Pictures minimum requirements 700 x 400 pixels.</label>
            <div class="row">
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Labeled bagged part" Picture={Pic1Img} onPictureChange={handlePictureUpdate_1} isRequired={true}/>
              </div>
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Label" Picture={Pic2Img} onPictureChange={handlePictureUpdate_2} isRequired={true}/>
              </div>
            </div>
            <div class="row">
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Cushioning material" Picture={Pic3Img} onPictureChange={handlePictureUpdate_3} isRequired={true}/>
              </div>
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Open box with part inside" Picture={Pic4Img} onPictureChange={handlePictureUpdate_4} isRequired={true}/>
              </div>
            </div>
            <div class="row">
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Inserts, pads, straps, others" Picture={Pic5Img} onPictureChange={handlePictureUpdate_5} isRequired={false}/>
              </div>
              <div className="col-6 bordered-box">
                <ImageUploadSection title="Closed box with label." Picture={Pic6Img} onPictureChange={handlePictureUpdate_6} isRequired={true}/>
              </div>
            </div>
          </div>
          {/* Section 5 - Attachments */}
          <div className="row"> <div className="col-12"><h5 className="generalInfoStyle">Section H - Attachments</h5></div></div>
          <div class="row">
            <div class="col-2">
              <label for="subject">Attachments</label>
            </div>
            <div class="col-10">
              <input type="file" onChange={(e) => setSelectedFile(e.target.files ? e.target.files : null)} multiple />
            </div>
          </div>


          <div class="row">
            <div>
              <input type="checkbox" value={isConfirmChecked} style={{ color: 'red', width: '22px', height: '22px', verticalAlign: 'middle' }} onChange={handleChangeConfirmCheckbox} required />&nbsp;&nbsp; <label style={{ color: 'red' }}>I confirm this form and attached document(s) DO NOT contain any technical information subject to EAR, ITAR or ECL</label>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <input type="submit" value="Submit" /> &nbsp;
              <input type="button" value="Home" onClick={onClickHomeHandler} /> &nbsp;
              <input type="button" value="Cancel" onClick={onClickCancelHandler} />
            </div>
          </div>
          <div class="row">
            <div class="col-10 text-success">
              <Modal
                show={modelPopupshow}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> UPPAP Packaging, Preservation & Labelling</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p> Your UPPAP Packaging Finished Parts approval request has been submitted.</p>
                  <p> You will receive an email with the request information and details for tracking purposes.</p>
                  <p> Please reach out to your buyer in case of any issues or concerns regarding your request.</p>
                  <p> Click <strong><mark>OK</mark></strong> to return to the home page.</p>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleOkButtonModelPopup}>
                    OK
                  </Button>
                </Modal.Footer>
              </Modal>
              <Modal
                show={loading}
                onHide={handleOkButtonModelPopup}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Header style={{ backgroundColor: '#1f2a44', color: 'white' }}>
                  <Modal.Title> Request in-progress, please wait...</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <p>Loading....</p>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </form>
    )
  } else {
    return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
  }
}

export default NewFinishedPartRequstForm;
